import React from 'react';

interface IProps {
	children?: any;
}
interface IState {
	error: string | null;
}
class ErrorBoundary extends React.Component<IProps, IState> {
	static getDerivedStateFromError(error: Error | null) {
		return { error };
	}

	state = {
		error: null
	};

	componentDidCatch(error: Error | null) {
		this.logError(error);
	}

	render() {
		if (this.state.error) {
			return 'Application has errors. Please check logs to fix this';
		}
		return this.props.children;
	}

	logError(args: Error | null) {
		console.log(args);
	}
}

export default ErrorBoundary;
